import React, { useCallback } from 'react';
import { di } from 'react-magnetic-di';
import { fg } from '@atlaskit/platform-feature-flags';
import { useFormIndexState } from '../../../controllers/form-index';
import { FormCardBody } from './form-card-body';
import { FormCardHeader } from './form-card-header-new';
import { FormBodyWrapper, FormCardContainer } from './styled';
export const FormCard = ({
  form,
  formStore,
  ufoExperience,
  onFormSelected,
  onFormSelectedOld,
  linkedFieldNames,
  renderMenu,
  onCancelEdit,
  projectType,
  hideLockedLozenge,
  isFirstForm
}) => {
  const {
    selectedFormId
  } = useFormIndexState();
  const formIsSelected = selectedFormId === form.id;

  // Card header callbacks
  const toggleExpanded = useCallback(() => {
    if (fg('granular_permissions_on_forms_ga')) {
      onFormSelected(formIsSelected ? undefined : {
        formId: form.id,
        hasAccess: form.hasAccess
      });
    } else {
      onFormSelectedOld(formIsSelected ? undefined : form.id);
    }
  }, [onFormSelected, onFormSelectedOld, formIsSelected, form.id, form === null || form === void 0 ? void 0 : form.hasAccess]);
  return /*#__PURE__*/React.createElement(FormCardContainer, {
    "data-testid": `proforma-form-index-form-card-container-${form.id}`,
    isFormYellow: form.internal && projectType === 'service_desk',
    formIsSelected: formIsSelected
  }, /*#__PURE__*/React.createElement(FormCardHeader, {
    form: form,
    formStore: formStore,
    toggleExpanded: toggleExpanded,
    renderMenu: renderMenu,
    onCancelEdit: onCancelEdit,
    projectType: projectType,
    hideLockedLozenge: hideLockedLozenge,
    isFirstForm: isFirstForm
  }), formIsSelected && /*#__PURE__*/React.createElement(FormBodyWrapper, null, /*#__PURE__*/React.createElement(FormCardBody, {
    form: form,
    ufoExperience: ufoExperience,
    linkedFieldNames: linkedFieldNames,
    onCancelEdit: onCancelEdit,
    projectType: projectType
  })));
};